import {gql} from "@apollo/client";

export const GET_SORTER_LISTING = gql`
    query GetSorterListing($filters: SorterFiltersInput, $pageRequest: SorterPageRequestInput) {
        getSorterListing(filters: $filters, pageRequest: $pageRequest) {
            content {
                id
                sorterCode
                sorterName
                sorterIp
                sorterPort
                sorterStatus
                sorterType
                warehouseId
                chuteConfig
                disabledChuteConfig
                createdAt
                createdBy
                updatedAt
                updatedBy
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface SorterListingResponse {
    getSorterListing: SorterListingResponseType;
}

export interface SorterListingResponseType {
    content: SorterType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface SorterType {
    id: string;
    sorterCode?: string;
    sorterName?: string;
    sorterIp?: string;
    sorterPort?: string;
    sorterStatus: number;
    sorterType: number;
    warehouseId: number;
    chuteConfig: string;
    disabledChuteConfig?: string;
    createdAt?: number;
    createdBy?: string;
    updatedAt?: number;
    updatedBy?: string;
}

export interface SorterPageRequestInput {
    page?: number;
    size?: number;
    sortBy?: string;
    sortDirection?: 'ASC' | 'DESC';
}

